export const LOAD_STATE = 'LOAD_STATE';
export const SET_LOADING = 'SET_LOADING';
export const SET_MENU_ID = 'SET_MENU_ID';
export const SET_MENU_LEVEL = 'SET_MENU_LEVEL';
export const API_ERRORS = 'API_ERRORS';
